import { addNamespace } from '@/app/shared/utils/NamespaceHelper'
import longGrid, { Types as TypesLongGrid } from '@/app/shared/store/modules/LongGrid'
import Dimension from '@/app/shared/models/Dimension'

export const NAMESPACE = 'monthlySales'
const INTERNAL_NAMESPACE = NAMESPACE + '/'

const metricsNormalCurrentYear = [
  'quantity_sold_2',
  'quantity_sold_1',
  'real_sales_amount_2',
  'real_sales_amount_1',
  'real_sales_cost_2',
  'real_sales_cost_1'
]

const buildMonthlySalesParameters = (month) => {
  return {
    calculatedField: [
      'COALESCE((SUM(real_sales_amount_1) - SUM(real_sales_cost_1)) / NULLIF(SUM(real_sales_amount_1),0), 0) as mg_1',
      'COALESCE((SUM(real_sales_amount_2) - SUM(real_sales_cost_2)) / NULLIF(SUM(real_sales_amount_2),0), 0) as mg_2'
    ],
    factTableName: 'dw_monthly_sales_comparative',
    metrics: {
      normal: metricsNormalCurrentYear,
      var: [
        'quantity_sold',
        'real_sales_amount',
        'real_sales_cost'
      ]
    },
    dateFilters: {
      month: {
        operator: 'BT',
        value: [month, month]
      }
    }
  }
}

const _types = {
  getters: {
    BASE_DIMENSION: 'BASE_DIMENSION',
    PIVOT_DIMENSIONS: 'PIVOT_DIMENSIONS'
  },
  actions: {
    INIT: 'INIT',
    CHANGE_BASE_DIMENSION: 'CHANGE_BASE_DIMENSION',
    CHANGE_PIVOT: 'CHANGE_PIVOT',
    INIT_LONG_GRID: 'INIT_LONG_GRID',
    APPLY_FILTERS: 'APPLY_FILTERS',
    POP_UNTIL_BREADCRUMB: 'POP_UNTIL_BREADCRUMB',
    DOWNLOAD_GRID_TO_EXCEL: 'DOWNLOAD_GRID_TO_EXCEL',
    RESET: 'RESET'
  },
  mutations: {
    SET_DIMENSIONS: 'SET_DIMENSIONS',
    SET_METRIC: 'SET_METRIC'
  }
}

export const Types = addNamespace(INTERNAL_NAMESPACE, _types)

const Index = {
  namespaced: true,
  state: {
    dimensions: null,
    metric: null
  },
  getters: {
    [_types.getters.BASE_DIMENSION]: (state, getters) => {
      return getters[TypesLongGrid.getters.BASE_DIMENSION]
    },
    [_types.getters.PIVOT_DIMENSIONS]: (state, getters) => {
      return getters[TypesLongGrid.getters.PIVOT_DIMENSIONS]
    }
  },
  actions: {
    [_types.actions.INIT] ({ commit }, { dataDimensions, metric }) {
      const dimensions = dataDimensions.map((dimension) => new Dimension(dimension))
      commit(_types.mutations.SET_DIMENSIONS, dimensions)
    },
    async [_types.actions.INIT_LONG_GRID] ({ dispatch, state }, month) {
      const defaultDimension = state.dimensions[0]
      await dispatch(TypesLongGrid.actions.INIT, { dimensions: state.dimensions, defaultDimension, defaultParameters: buildMonthlySalesParameters(month), filters: state.longGrid.filters })
    },

    async [_types.actions.CHANGE_BASE_DIMENSION] ({ dispatch }, dimensionId) {
      await dispatch(TypesLongGrid.actions.CHANGE_BASE_DIMENSION, dimensionId)
    },
    async [_types.actions.CHANGE_PIVOT] ({ dispatch, rootState }, { params, option }) {
      await dispatch(TypesLongGrid.actions.CHANGE_PIVOT, { params, option })
    },
    async [_types.actions.APPLY_FILTERS] ({ dispatch }, { storeFilters, productFilters, asyncProductPool }) {
      await dispatch(TypesLongGrid.actions.APPLY_FILTERS, { storeFilters, productFilters, asyncProductPool })
    },
    async [_types.actions.POP_UNTIL_BREADCRUMB] ({ dispatch }, breadCrumbItem) {
      await dispatch(TypesLongGrid.actions.POP_UNTIL_BREADCRUMB, breadCrumbItem)
    },
    async [_types.actions.DOWNLOAD_GRID_TO_EXCEL] ({ dispatch }) {
      await dispatch(TypesLongGrid.actions.DOWNLOAD_GRID_TO_EXCEL)
    },
    [_types.actions.RESET] ({ dispatch }) {
      dispatch(TypesLongGrid.actions.RESET)
    }
  },
  mutations: {
    [_types.mutations.SET_DIMENSIONS] (state, dimensions) {
      state.dimensions = dimensions
    },
    [_types.mutations.SET_METRIC] (state, metric) {
      state.metric = metric
    }
  },
  modules: {
    longGrid
  }
}
export default Index



// WEBPACK FOOTER //
// ./src/app/monthly_sales/store/Index.js